export default __webpack_public_path__ + "static/media/sotrudnik-mob.2556edf6.jpg";